/**
 * @generated SignedSource<<de061c48181aec7db473f5d342dfe356>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RecapTemplateType = "BANT" | "CUSTOMER_SUCCESS" | "MEDDIC" | "SALES_DISCOVERY" | "SALES_FOLLOW_UP" | "SPICED";
export type Associations = {
  companyIds?: ReadonlyArray<string | null> | null;
  contactIds?: ReadonlyArray<string | null> | null;
  dealIds?: ReadonlyArray<string | null> | null;
};
export type HubspotSendNotesMutation$variables = {
  associations?: Associations | null;
  includeRecap: boolean;
  noteId: string;
  recapTemplateType?: RecapTemplateType | null;
  sendActionItems: boolean;
};
export type HubspotSendNotesMutation$data = {
  readonly sendNoteToHubspotAsCall: {
    readonly error: string | null;
    readonly id: string | null;
    readonly noteVersion: number | null;
    readonly ok: boolean;
    readonly url: string | null;
  } | null;
};
export type HubspotSendNotesMutation = {
  response: HubspotSendNotesMutation$data;
  variables: HubspotSendNotesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "associations"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeRecap"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recapTemplateType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sendActionItems"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "associations",
            "variableName": "associations"
          },
          {
            "kind": "Variable",
            "name": "includeRecap",
            "variableName": "includeRecap"
          },
          {
            "kind": "Variable",
            "name": "noteId",
            "variableName": "noteId"
          },
          {
            "kind": "Variable",
            "name": "recapTemplateType",
            "variableName": "recapTemplateType"
          },
          {
            "kind": "Variable",
            "name": "sendActionItems",
            "variableName": "sendActionItems"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "SendNoteToHubspotAsCallPayload",
    "kind": "LinkedField",
    "name": "sendNoteToHubspotAsCall",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "noteVersion",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HubspotSendNotesMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "HubspotSendNotesMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "e88443ffb106f317d1216ea74c20859b",
    "id": null,
    "metadata": {},
    "name": "HubspotSendNotesMutation",
    "operationKind": "mutation",
    "text": "mutation HubspotSendNotesMutation(\n  $noteId: String!\n  $associations: Associations\n  $includeRecap: Boolean!\n  $sendActionItems: Boolean!\n  $recapTemplateType: RecapTemplateType\n) {\n  sendNoteToHubspotAsCall(input: {noteId: $noteId, associations: $associations, includeRecap: $includeRecap, sendActionItems: $sendActionItems, recapTemplateType: $recapTemplateType}) {\n    ok\n    error\n    id\n    url\n    noteVersion\n  }\n}\n"
  }
};
})();

(node as any).hash = "091217b676f85b47b74404afb60a0e5d";

export default node;
